module.exports = __webpack_public_path__ + "img/cafe_depot.620c35f5.webp";